export const DMSEndpoints = [
  {
    baseUrl: "seulah",
    name: "customer/screen/getAllScreenWithQuestionDetail",
    alias: "getAllScreenWithQuestionDetail",
    path: "dms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/screen/getUserDetailsByUserId",
    alias: "getUserDetailsByUserId",
    path: "dms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/eligibilityCheck/updateAndCheck",
    alias: "updateAndCheck",
    path: "dms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/policy/fetchLoanPolicyAgeLimits",
    alias: "fetchLoanPolicyAgeLimits",
    path: "dms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/policy/fetchLoanPolicySalaryLimits",
    alias: "fetchLoanPolicySalaryLimits",
    path: "dms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/eligibilityCheck/expenseIncomeValidation",
    alias: "expenseIncomeValidation",
    path: "dms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "policies/finance-calculator",
    alias: "financeCalculator",
    path: "dms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "policy/fetchPrincipalLoanLimit",
    alias: "fetchPrincipalLoanLimit",
    path: "dms",
    noToken: true,
    runAt: "onDemand",
    hideLoader: true,
  },

]

export const DMSEndpointsMapping = {
  GetAllScreenWithQuestionDetail: 'getAllScreenWithQuestionDetail',
  GetUserDetailsByUserId: 'getUserDetailsByUserId',
  UpdateAndCheck: 'updateAndCheck',
  FetchLoanPolicyAgeLimits: 'fetchLoanPolicyAgeLimits',
  FetchLoanPolicySalaryLimits: 'fetchLoanPolicySalaryLimits',
  ExpenseIncomeValidation: 'expenseIncomeValidation',
  FinanceCalculator: 'financeCalculator',
  FetchPrincipalLoanLimit: 'fetchPrincipalLoanLimit',
}